module.exports = __webpack_public_path__ + "img/collectionTip.975a5b82.png";